import React from 'react';
import { Logo } from './Logo';
import { navLinks, site } from '../data/site';
export function Footer() {
  return <footer className="border-t border-forest-line/70 bg-forest-deep py-14" data-id="element-36" data-mp="3ggaq1tbg494e">
      <div className="mx-auto flex max-w-shell flex-col gap-10 px-5 sm:px-8 md:flex-row md:items-start md:justify-between" data-id="element-37" data-mp="32oe1u0cwejda">
        <div className="max-w-xs" data-id="element-38" data-mp="36q9354utwwr2">
          <Logo data-id="element-39" data-mp="36nd6rkymqg4q" />
          <p className="mt-5 text-sm text-cream-muted" data-id="element-40" data-mp="3uf0mr7ucs6s8">
            {site.date} · {site.location}. For ecommerce CFOs, by ecommerce
            CFOs.
          </p>
        </div>

        <nav aria-label="Footer" data-id="element-41" data-mp="36mskisw8wry">
          <ul className="grid grid-cols-2 gap-x-12 gap-y-3" data-id="element-42" data-mp="3levhb38pzigp">
            {navLinks.map(link => <li key={link.href} data-id="element-43" data-mp="3qcxa4fvy6w5d">
                <a href={link.href} className="text-sm text-cream-dim transition-colors hover:text-cream" data-id="element-44" data-mp="3qbvmzd1nqj7a">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>
      </div>

      <div className="mx-auto mt-12 max-w-shell border-t border-forest-line/60 px-5 pt-6 sm:px-8" data-id="element-45" data-mp="3lalfndz543tf">
        <p className="text-xs text-cream-muted" data-id="element-46" data-mp="3gbilwpom1k0r">
          © {new Date().getFullYear()} Count Club. All rights reserved.
        </p>
      </div>
    </footer>;
}